import { RootState } from 'store/store';

export const selectpifCreationStatus = (state: RootState) => state.pif.pifCreationStatus;
export const selectProjectDetailsData = (state: RootState) => state.pif.projectDetailsData;
export const selectprojectId = (state: RootState) => state.pif.projectId;
export const selectpifUpdateStatus = (state: RootState) => state.pif.pifUpdateStatus;
export const selectProjectDetailsStatus = (state: RootState) => state.pif.projectDetailsStatus;
export const selectProjectSubmitReviewStatus = (state: RootState) => state.pif.projectSubmitReviewStatus;
